/** Past rounds cannot be re-enabled once a later round has started or completed. */
export function isRoundLocked(round, rounds = []) {
  if (!round) return true;
  if (round.round_status === "completed") return true;
  return rounds.some(
    (r) =>
      r.round_order > round.round_order &&
      (r.round_status === "completed" ||
        r.round_status === "active" ||
        Boolean(r.is_enabled))
  );
}

export function canEnableRound(round, rounds = [], fnStatus = "off") {
  if (fnStatus !== "live" || !round) return false;
  if (Boolean(round.is_enabled)) return false;
  if (isRoundLocked(round, rounds)) return false;
  const otherActive = rounds.some((r) => r.id !== round.id && Boolean(r.is_enabled));
  if (otherActive) return false;
  return true;
}

export function getRoundLockReason(round, rounds = [], fnStatus = "off") {
  if (fnStatus !== "live") return "Start Final Night first";
  if (round?.round_status === "completed") return "This round is completed";
  if (isRoundLocked(round, rounds)) return "Cannot re-enable a previous round";
  const otherActive = rounds.find((r) => r.id !== round?.id && Boolean(r.is_enabled));
  if (otherActive) return `Stop or complete ${otherActive.name} first`;
  return null;
}
